import { useHistory } from 'react-router-dom'
import { useMount } from 'react-use'
import AppError, { ERROR_TYPE } from 'lib/errors'
import { useEffect, useState } from 'react'
import queryString from 'query-string'
import { useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

/**
 * Check if url contains identification-error query param and if so return it as AppError object.
 * @returns {null|AppError}
 */
const useIdentificationError = (vehicleId, vertical) => {
    const history = useHistory()
    const { i18n } = useTranslation()
    const [appError, setAppError] = useState(null)

    useEffect(() => {
        if (appError?.code === 10067 || appError?.code === 10110 || appError?.code === 10111) {
            const pathName = (vehicleId && vertical && appError?.code !== 10067)
                ? `${getLocale(i18n.language)}/virhe-tunnistautumisessa/${appError.code}/${vertical}/${vehicleId}`
                : `${getLocale(i18n.language)}/virhe-tunnistautumisessa/${appError.code}`

            history.push({
                pathname: pathName,
                state: {
                    appError
                }
            })
        }
    }, [appError, history, vehicleId, vertical, i18n.language])

    useMount(() => {
        const paramName = 'identification-error'

        const queryParams = queryString.parse(history.location.search)

        if (queryParams[paramName]) {
            const code = parseInt(queryParams[paramName])
            if (!isNaN(code)) {
                setAppError(new AppError(
                    ERROR_TYPE.MY_NETTIX,
                    code,
                    'Strong identification error'
                ))
            }
        }
    })

    return appError
}

export default useIdentificationError
